import '../css/Header.css';

function Header({title, onShowCodeModal, onShowConfigPanel} ) {
  // Controlla se c'è già un codice salvato
  const savedCode = localStorage.getItem('cockpit_user_code');
  const hasCode = savedCode && savedCode.length > 0;
  
  // Non imposta nessun codice predefinito al primo accesso

return(
  <div className="header">
    <h1 className="headerContent">{title}</h1>
    <div className="header-buttons">
      {onShowConfigPanel && (
        <button 
          className="config-button"
          onClick={onShowConfigPanel}
          title="Configurazione Card"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path d="M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.64l-1.92-3.32c-.12-.22-.37-.3-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94L14.4 2.81c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.22-.08.5.12.64l2.03 1.58c-.05.3-.07.62-.07.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.64l1.92 3.32c.12.22.37.3.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.5-.12-.64l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z" fill="currentColor"/>
          </svg>
        </button>
      )}
      {onShowCodeModal && (
        <button 
          className="code-button"
          onClick={onShowCodeModal}
          title={hasCode && savedCode !== 'Ab1cD2eF3gH' ? "" : "Verifica autorizzazione codice"}
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 11H3V9H9V11ZM9 15H3V13H9V15ZM9 7H3V5H9V7ZM11 5V19H21V5H11ZM19 17H13V15H19V17ZM19 13H13V11H19V11ZM19 9H13V7H19V7Z" fill="currentColor"/>
          </svg>
          {hasCode && savedCode !== 'Ab1cD2eF3gH' ? "" : ""}
        </button>
      )}
    </div>
  </div>
)
};


export default Header;